export enum RightSidebar {
    NOTIFICATION = 'NOTIFICATION',
    BET_HISTORY = 'BET_HISTORY',
}

export interface NotificationIF {
    date: Date
    message: string
}
